module.exports = __webpack_public_path__ + "h5/img/child-navc2.3770a3ea.png";